var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0BAB63CC-8A12-488D-AA2C-520BD193C064") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-3-Copy-8",
    transform: "translate(-1172.000000, -6117.000000)",
    fill: "#17171B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 5672.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1121.000000, 445.828678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(51.980100, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0149254,0 L4.00497512,0 C1.80243436,0 0,1.80276493 0,4.00744879 L0,12.0223464 C0,14.2262475 1.80243436,16.0297952 4.00497512,16.0297952 L12.0149254,16.0297952 C14.2174661,16.0297952 16.0199005,14.2262475 16.0199005,12.0223464 L16.0199005,4.00744879 C16.0199005,1.80276493 14.2174661,0 12.0149254,0 Z M8.00995025,11.3543078 C6.16644925,11.3543078 4.67240579,9.85871537 4.67240579,8.01489758 C4.67240579,6.17025794 6.16644925,4.6752917 8.00995025,4.6752917 C9.85262992,4.6752917 11.3474947,6.17025794 11.3474947,8.01489758 C11.3474947,9.85871537 9.85262992,11.3543078 8.00995025,11.3543078 Z M12.3487385,4.6752917 C11.7952384,4.6752917 11.3474947,4.22664528 11.3474947,3.6734295 C11.3474947,3.12021372 11.7952384,2.6715673 12.3487385,2.6715673 C12.9022386,2.6715673 13.3499823,3.12021372 13.3499823,3.6734295 C13.3499823,4.22664528 12.9022386,4.6752917 12.3487385,4.6752917 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.a05e62d02f500a10759b6bcb0828f4a1.svg";
export { ForwardRef as ReactComponent };